import { bool, func, object, string } from 'prop-types'
import { useContext, useState } from 'react'
import { kuiperClassNames } from '@opallabs/kuiper'
import { AnalyticsLayer } from '@opallabs/quanta'
import phaseContainerContext from '../PhaseList/PhaseContainer/phaseContainerContext'
import phaseListContext from '../PhaseList/phaseListContext'
import ApprovalControls from './ApprovalControls'
import ApprovalInfo from './ApprovalInfo'

import './styles.scss'

const InlineApproval = ({
  approval,
  entitySaveMethod,
  isDirtyCheck,
  status,
  willCompletePhase,
  updateApproval,
}) => {
  const [approvalSubmitted, setApprovalSubmitted] = useState(
    status !== 'pending'
  )
  const [feedback, setFeedback] = useState(approval.comment)
  const { getWorkflow } = useContext(phaseListContext)
  const { setIsUpdatingLocalPhase } = useContext(phaseContainerContext)

  const saveAndApprove = (newStatus) => {
    const savedMoment = entitySaveMethod()
    const isSavedCheck = setInterval(() => {
      if (savedMoment.isSaving !== true) {
        sendApproval(newStatus)
        clearInterval(isSavedCheck)
      }
    }, 300)
    setTimeout(() => clearInterval(isSavedCheck), 8000)
  }

  const sendApproval = (newStatus) => {
    updateApproval(
      {
        id: approval.approval_id,
        response: feedback,
        status: newStatus,
      },
      getWorkflow
    )

    setApprovalSubmitted(true)
    // conditionally renders phase loader or PhaseList
    if (willCompletePhase || newStatus === 'rejected') {
      setIsUpdatingLocalPhase(true)
    }
  }

  return (
    <div
      className={kuiperClassNames('inline-approval', {
        'no-feedback': approvalSubmitted && !feedback.length,
      })}
    >
      {!approvalSubmitted && (
        <AnalyticsLayer name="Inline Approval Controls">
          <ApprovalControls
            approve={() =>
              isDirtyCheck && isDirtyCheck()
                ? saveAndApprove('complete')
                : sendApproval('complete')
            }
            decline={() => sendApproval('rejected')}
            feedback={feedback}
            setFeedback={setFeedback}
          />
        </AnalyticsLayer>
      )}
      {approvalSubmitted && <ApprovalInfo feedback={feedback} />}
    </div>
  )
}

InlineApproval.propTypes = {
  approval: object,
  status: string,
  entitySaveMethod: func,
  isDirtyCheck: func,
  updateApproval: func,
  willCompletePhase: bool,
}

export default InlineApproval

export { InlineApproval }
